import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Table, Button } from 'react-bootstrap';
import { Box } from 'reactjs-admin-lte';
import { humanizeBytes } from 'misc/utils';
import EmptyRow from 'components/core/EmptyRow';


const MHTJobReferences = (props) => {
  const {
    references,
    isLoading,
    downloadReference,
  } = props;
  return (
    <Box className="box-widget mb-10" loading={isLoading}>
      <Box.Header>
        <Box.Title>References</Box.Title>
        <Box.Tools>
          <Box.CollapsedToggleButton />
        </Box.Tools>
      </Box.Header>
      <Box.Body noPadding={true}>
        <Table striped bordered className="mb-0">
          <thead>
            <tr>
              <th width="40%">Filename</th>
              <th>Size</th>
            </tr>
          </thead>
          <tbody>
          { references && references.length > 0
            ? references.map(s => (
              <tr key={s.id}>
                <td>
                  {s.stored
                    ? (<a onClick={e => downloadReference(e, s)}>{s.name}</a>)
                    : s.name
                  }
                </td>
                <td>{humanizeBytes(s.size)}</td>
              </tr>
            ))
            : <EmptyRow colSpan={2} />
          }
          </tbody>
        </Table>
      </Box.Body>
    </Box>
  )
}

export default MHTJobReferences;